import React from "react";

const Scheduling = () => <div>Scheduling</div>;

export default Scheduling;
